import React from "react";
import Cookies from 'universal-cookie';
import { useNavigate, useSearchParams } from "react-router-dom";
import { getCsrfToken , loginFunc} from "../services/authApiRoutes/APImethods";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { loginSessionDetail } from '../redux/reducers/LoginSessionSlice';
import { logError } from "../services/authApiRoutes/APImethods";

export default function LoginRedirection() {

  const [params ,setParams] = useSearchParams();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const dispatch = useDispatch();


  useEffect( ()=>{
    const csrfToken = getCsrfToken();
      const reqJson = {
        callback_id : params.get('cbid')
      };
      loginFunc(reqJson).then(response => {
        if(response.data.msg === "login successful"){
          var userInfo = response.data.userInfo.data;
          cookies.set('userEmail', userInfo.email, { path: '/' });
          cookies.set('i18nextLng', userInfo.locale, { path: '/' });
          dispatch(loginSessionDetail(userInfo));
          localStorage.setItem('role', JSON.stringify(userInfo.role));
          navigate("/home");
        }else{
          navigate("/login");
        }
      }).catch((err) => {
        const errorMessage = "Error while login. Reason: ";
        logError(errorMessage, err.message); 
      })
  },[])

  return (
    <div>
        <div>Loading Dashboard ..</div>
    </div>
  );
}
